import {Brick, BrickContext, ErrorFlow, Query, registerBrick} from 'olympe';
import Assessment from "../../../../models/Assessment";
import Unit from "../../../../models/Unit";
import System from "../../../../models/System";
import Component from "../../../../models/Component";
import Observation from "../../../../models/Observation";
import AHPValue from "../../../../models/AHPValue";
import Aspect from "../../../../models/Aspect";
import InspectionResultMapping from "../../../../models/InspectionResultMapping";

export default class LoadReportData extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Assessment} assessment
     * @param {function()} forwardEvent
     * @param {function(ErrorFlow)} setErrorFlow
     * @param {function(Assessment)} setReport
     */
    async update($, [assessment], [forwardEvent, setErrorFlow, setReport]) {
        // 1. Get the units and systems tree
        const components = assessment.follow(Assessment.unitsRel)
            .follow(Unit.systemsRel).andReturn()
            .follow(System.allComponentsRel).andReturn()
            .follow(AHPValue.itemRel.getInverse(), true).andReturn()
            .follow(AHPValue.aspectRel)
            .execute();

        const systemComponentsRels = assessment.follow(Assessment.unitsRel).andReturn()
            .follow(Unit.systemsRel)
            .follow(System.componentsRel)
            .execute();

        const subComponentsRels = assessment.follow(Assessment.unitsRel).andReturn()
            .follow(Unit.systemsRel)
            .follow(System.allComponentsRel)
            .follow(Component.subComponentsRel)
            .execute();

        const inspections = assessment.follow(Assessment.unitsRel)
            .follow(Unit.systemsRel)
            .follow(System.allComponentsRel)
            .follow(Component.inspectionsRel).andReturn()
            .follow(AHPValue.itemRel.getInverse(), true).andReturn()
            .follow(AHPValue.aspectRel)
            .execute();

        const observations = assessment.follow(Assessment.unitsRel)
            .follow(Unit.observationsRel).andReturn()
            .follow(Observation.targetRel)
            .execute();

        const evaluatedObs = assessment.follow(Assessment.unitsRel)
            .follow(Unit.observationsRel)
            .follow(Observation.evalutationRel).andReturn()
            .execute();

        // 2. Get some static data
        const aspects = Query.instancesOf(Aspect).execute();
        const resultMapping = Query.instancesOf(InspectionResultMapping).execute();

        try {
            const loadedData = await Promise.all([components, systemComponentsRels, subComponentsRels, inspections, observations, evaluatedObs, aspects, resultMapping]);
            $.set('loadedData', loadedData);
            $.onClear(() => $.remove('loadedData'));
            setReport(assessment);
            forwardEvent();
        } catch(e) {
            setErrorFlow(ErrorFlow.create(`Error while downloading unit data for the report: ${e}`, 1));
        }
    }
}

registerBrick('018afb40c47805c6b2f3', LoadReportData);
